// libraries.
import { Table } from "react-bootstrap";

// hooks.
import { UsedComparables } from "@store/apiSlices/historyLeadInfo/historyLeadInfo.endpoints";

// components.
import { SourceBadgeTags } from "@shared/SourceBadges/SourceBadges";

// styles.
import { WrapperTable } from "../CalculationsTableMX/styles";

// utils.
import { tableHeaders } from "../../utils";
import { useGetHistoryLeadInfo } from "@store/apiSlices/historyLeadInfo/historyLeadInfo.hooks";
import { formatPrice } from "@utils/formatPrice.utils";
import { NormalizedClientPrice } from "../NormalizedPrice/NormalizedClient";
import { NormalizedM2Price } from "../NormalizedPrice/NormalizedM2Price";

interface TableCOProps {
  comparablesList: UsedComparables[];
}

export const TableCO = ({ comparablesList }: TableCOProps) => {
  const {
    getHistoryLeadInfoQuery: { data },
  } = useGetHistoryLeadInfo();

  const tableList = comparablesList?.map((item) => {
    const isOutlier = data?.outliers?.includes(item.comparable_id) ?? false;
    if (isOutlier) {
      return {
        ...item,
        isOutlier,
      };
    }
    return item;
  });
  const tableBody = () => {
    return (
      <tbody>
        {tableList?.map((comparable, rowIndex) => (
          <tr key={rowIndex}>
            <td
              className={comparable.isOutlier ? "outlier-numb" : "sticky-numb"}
            >
              {rowIndex + 1}
            </td>
            <td className={comparable.isOutlier ? "outlier-id" : "id"}>
              {comparable?.comparable_id}
            </td>
            <td>{comparable?.date_create || "null"}</td>
            <td>
              {
                <SourceBadgeTags color={comparable?.source_id}>
                  {comparable?.source_id}
                </SourceBadgeTags>
              }
            </td>
            <td>{comparable?.address || "null"}</td>
            <td>{comparable?.condominium || "null"}</td>
            <td>{comparable?.area || "null"}</td>
            <td>{comparable?.floor_num || "null"}</td>
            <td>{comparable?.room_num}</td>
            <td>{comparable?.banos || "null"}</td>
            <td>{comparable?.garage}</td>
            <td>{comparable?.elevator}</td>
            <td>{comparable?.years_old || "null"}</td>
            <td>{formatPrice(comparable?.last_ask_price)}</td>
            <td>
              {
                <NormalizedClientPrice
                  comparableId={comparable.comparable_id}
                />
              }
            </td>
            <td>
              {<NormalizedM2Price comparableId={comparable.comparable_id} />}
            </td>
            <td>{comparable?.gray_work || "null"}</td>
            <td>{"contact"}</td>
            <td>{comparable?.phone || "null"}</td>
            <td>{comparable?.property_type || "null"}</td>
          </tr>
        ))}
      </tbody>
    );
  };
  return (
    <WrapperTable>
      <Table responsive hover style={{ width: "2700px" }}>
        {tableHeaders()}
        {tableBody()}
      </Table>
    </WrapperTable>
  );
};
